// Check if the Overlay Layer element is already defined, if not, define it
if (!customElements.get('overlay-layer')) {
    class OverlayLayer extends HTMLElement {
        static get observedAttributes() {
            return ['active-layer'];
        }

        DeActivateOverlay() {
            // Set the DataValue so CSS can Apply Styles and UnLock Html Element so Scrolling is allowed from abscenece of Locked Class
            theme.InitialCarouselSlide = 0
            this.setAttribute('data-active', false);
            this.DeActivateLayers()
            UnLockScroll()
        }
        
        ActivateOverlay() {
            // Set the DataValue so CSS can Apply Styles and Lock Html Element so no Scrolling via Locked Class
            this.setAttribute('data-active', true);
            LockScroll()
        }

        DeActivateLayers() {
            // Get all .Overlays and Deactivate them
            const Overlays = this.querySelectorAll('.Overlay');
            Overlays.forEach((element) => {
                element.setAttribute('data-active', 'false');
            });
        }

        ActivateLayer(string){
            this.DeActivateLayers()
            const TargetOverlay = this.querySelector(`#${string}`);
            if (TargetOverlay) {
                this.ActivateOverlay()
                TargetOverlay.setAttribute('data-active', 'true');
                this.dataset.currentOverlay = string
            }
            else {
                this.DeActivateOverlay()
            }

        }
        InjectLayer(Target, ContentCopy) {
            const TargetOverlay = this.querySelector(Target)
            if (TargetOverlay && ContentCopy ) {
                while (TargetOverlay.firstChild) {
                    TargetOverlay.removeChild(TargetOverlay.firstChild);
                    TargetOverlay.innerHTML = ''
                }
                TargetOverlay.append(ContentCopy)
            }
        }
        
        attributeChangedCallback(name, oldValue, newValue) {
            if (name === 'active-layer') {
                this.updateActiveLayer(newValue);
            }
        }
    
        updateActiveLayer(newLayerId) {
            this.DeActivateLayers()

            this.ActivateLayer(newLayerId)
        }
    
        set activeLayer(value) {
            this.setAttribute('active-layer', value);
        }
    
        get activeLayer() {
            return this.getAttribute('active-layer');
        }

        constructor() {
            super();

            // Setup Background Layer for Quick Close
            this.backgroundLayer = this.querySelector('#OverlayBackgroundDiv')
            this.backgroundLayer.addEventListener('click', () => {
                this.DeActivateOverlay()
            });

            // Set No Pointer Events until its data-active is set to true
            this.style.pointerEvents = 'none';
            this.addEventListener('transitionend', function() {
                if (this.getAttribute('data-active') === 'false') {
                    this.style.pointerEvents = 'none';
                } else {
                    this.style.pointerEvents = 'all';
                }
            });
            
            theme.Overlay = this
        }
    }
    customElements.define('overlay-layer', OverlayLayer);
}